import { history } from "./nav.history";

class NavService {
  push(to: any, state?: object) {
    // Kiểm tra nếu URL có dạng ?code= và tự động thêm /product nếu chưa có
    // const path = this.addProductIfNeeded(to);
    history.navigate(to, state);
  }

  reload() {
    window.location.reload();
  }

  private addProductIfNeeded(path: string): string {
    // Kiểm tra nếu path có ?code= mà không có /product
    const params = new URLSearchParams(path.includes('?') ? path.split('?')[1] : '');
    const code = params.get("code");

    const currentPath = path.split('?')[0];

    if (code && currentPath === '/') {
      // Nếu chỉ có ?code= mà không có /product, thêm /product vào
      return `/product?${params.toString()}`;
    }

    // Nếu không thì trả về nguyên path
    return path;
  }
}
/* eslint import/no-anonymous-default-export: [2, {"allowNew": true}] */
export default new NavService();
